import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

const VehicleUsageRejectedAlert = ({ className = "mt-3" }) => {
  const { t } = useTranslation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    axios
      .get("/api/vehicle-usage-logs/alerts", {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((res) => setCount(res.data?.rejectedUnprocessed || 0))
      .catch(() => setCount(0));
  }, []);

  if (!count) return null;

  return (
    <Alert variant="danger" className={className}>
      {t("fleet.usageLogAlert", { count })}{" "}
      <Link to="/admin/fleet/usage-logs" className="alert-link">
        {t("fleet.usageLogPageTitle")}
      </Link>
    </Alert>
  );
};

export default VehicleUsageRejectedAlert;
